import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronUp, Home as HomeIcon } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

const Layout = ({ children }) => {
  const [showTop, setShowTop] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <>
      <Nav />
      <main data-testid="main-content">{children}</main>
      <Footer />

      {!isHome && (
        <Link
          to="/"
          className="return-home"
          aria-label="Return to home"
          data-testid="return-home"
        >
          <HomeIcon size={16} />
          <span>Home</span>
        </Link>
      )}

      <button
        className={`btt ${showTop ? "vis" : ""}`}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Back to top"
        data-testid="back-to-top"
      >
        <ChevronUp size={18} />
      </button>
    </>
  );
};

export default Layout;
